import React, { useState } from 'react';
import { ChevronDown, HelpCircle } from 'lucide-react';
import { FadeIn } from './ui/FadeIn';
const faqs = [{
  q: '¿Cómo recibo la guía después de comprar?',
  a: 'Inmediatamente después del pago, recibirás un correo electrónico con el enlace de acceso directo a todo el material en formato PDF digital, listo para descargar en tu celular, tablet o computadora.'
}, {
  q: '¿Sirve si recién empiezo o es solo para avanzados?',
  a: 'El programa está diseñado para niveles intermedios y avanzados. Si ya dominás las dominadas y flexiones básicas y querés dar el salto a trucos más complejos, este sistema te dará la estructura exacta.'
}, {
  q: '¿Necesito equipamiento caro o me alcanza con una barra?',
  a: 'Podés realizar el 90% del programa solo con una barra de dominadas y el piso. Incluimos un bono sobre cómo armar equipamiento casero (como anillas o paralelas) si querés expandir tus opciones.'
}, {
  q: '¿Los 6 bonos están incluidos en las dos ofertas?',
  a: 'Sí, absolutamente. Tanto la versión estándar como el Pack Completo (Pro Élite) incluyen los 6 bonos estratégicos sin costo adicional.'
}, {
  q: '¿Sirve si entreno en un parque o gimnasio comercial?',
  a: 'Totalmente. Las rutinas son 100% adaptables a cualquier entorno. Solo necesitás tu cuerpo y una estructura básica para colgarte.'
}, {
  q: '¿Sirve si peso mucho o soy muy alto para la calistenia?',
  a: 'La biomecánica aplica para todos. El programa te enseña a adaptar las palancas y progresiones a tu tipo de cuerpo específico, enfocándose en la fuerza relativa.'
}, {
  q: '¿Qué diferencia tiene con tutoriales gratis en YouTube?',
  a: 'YouTube te da piezas sueltas de un rompecabezas. Este megapack te da el rompecabezas armado: una estructura secuencial, periodización, prevención de lesiones y un sistema que te dice exactamente qué hacer cada día.'
}, {
  q: '¿Por qué elegir el Pack Completo y no el estándar?',
  a: 'El Pack Completo incluye el sistema Pro Élite, ideal si estás estancado en trucos muy avanzados, querés aprender a encadenar combos (freestyle) o si te interesa empezar a coachear a otros y monetizar tu conocimiento.'
}, {
  q: '¿Tiene garantía real?',
  a: 'Sí, 7 días de garantía incondicional. Si no te sirve, mandás un mail y te devolvemos el dinero al instante.'
}];
export function FAQ() {
  const [openIndex, setOpenIndex] = useState<number | null>(null);
  return <section className="py-10 md:py-20 bg-brand-card" data-id="element-64">
      <div className="container mx-auto px-4 max-w-3xl" data-id="element-65">
        <FadeIn className="text-center mb-6 md:mb-10" data-id="element-66">
          <div className="inline-flex items-center gap-1.5 bg-brand-orange/10 border border-brand-orange/30 text-brand-orange px-3 py-1 rounded-full text-[10px] md:text-xs font-bold tracking-widest mb-3" data-id="element-67">
            <HelpCircle className="w-3 h-3" data-id="element-68" /> DUDAS COMUNES
          </div>
          <h2 className="text-2xl md:text-5xl" data-id="element-69">PREGUNTAS FRECUENTES</h2>
        </FadeIn>

        <div className="space-y-1.5 md:space-y-2" data-id="element-70">
          {faqs.map((faq, i) => {
          const isOpen = openIndex === i;
          return <FadeIn key={i} delay={i * 0.03} data-id="element-71">
                <div className={`border rounded-lg overflow-hidden transition-colors duration-200 ${isOpen ? 'border-brand-orange/50 bg-brand-dark' : 'border-brand-border bg-brand-dark hover:border-brand-orange/30'}`} data-id="element-72">
                  <button onClick={() => setOpenIndex(isOpen ? null : i)} className="w-full flex items-center justify-between px-3.5 py-3 md:px-5 md:py-4 text-left" aria-expanded={isOpen} data-id="element-73">
                    <span className="font-medium text-xs md:text-base pr-3 leading-snug" data-id="element-74">
                      {faq.q}
                    </span>
                    <ChevronDown className={`w-4 h-4 md:w-5 md:h-5 text-brand-orange shrink-0 transition-transform duration-300 ${isOpen ? 'rotate-180' : ''}`} data-id="element-75" />
                  </button>
                  <div className={`px-3.5 md:px-5 overflow-hidden transition-all duration-300 ease-in-out ${isOpen ? 'max-h-64 pb-3 md:pb-4 opacity-100' : 'max-h-0 opacity-0'}`} data-id="element-76">
                    <p className="text-[11px] md:text-sm text-brand-muted leading-relaxed pt-2 border-t border-brand-border/50" data-id="element-77">
                      {faq.a}
                    </p>
                  </div>
                </div>
              </FadeIn>;
        })}
        </div>
      </div>
    </section>;
}